module.exports = __webpack_public_path__ + "dist/img/qr.b29344e3.jpg";